import { z } from 'zod';

// Cassa Edile: CE = Cassa Edile, EC = Edilcassa
export const CASSE = ['CE', 'EC'] as const;
export const CassaCodeSchema = z.enum(CASSE);
export type CassaCode = z.infer<typeof CassaCodeSchema>;

// Alias per retrocompatibilità
export type CassaAttiva = CassaCode;
export const CassaAttivaSchema = CassaCodeSchema;

// Choices per CLI
export const cassaChoices = [
  { name: 'Cassa Edile (CE)', value: 'CE' as CassaCode },
  { name: 'Edilcassa (EC)', value: 'EC' as CassaCode },
] as const;

// Sesso
export const SessoSchema = z.enum(['M', 'F']).nullable();
export type Sesso = z.infer<typeof SessoSchema>;

// Stati lavoratore in posizione
export const StatoLavoratoreSchema = z.enum(['V', 'T', 'C', 'D', 'P']).nullable(); // P = pensionato (Edilcassa)
export type StatoLavoratore = z.infer<typeof StatoLavoratoreSchema>;

// Helper per campi nullable
export const str = z.string().nullable();
export const num = z.number().nullable();
export const dateStr = z.string().nullable(); // YYYY-MM-DD
export const periodoStr = z.string().nullable(); // YYYYMM
